var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-20 fs-17 fw-b text-color--dark-gray text-center" },
      [_vm._v(_vm._s(_vm.$t("risoltoRiskScore")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "risk-score" },
      [
        _c("el-rate", {
          attrs: { value: _vm.score, "allow-half": true, disabled: "" }
        })
      ],
      1
    ),
    _vm._v(" "),
    !_vm.score
      ? _c("div", { staticClass: "text-center fs-13" }, [
          _c("div", { staticClass: "p-5 text-color--gray" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("RecipientDetail.risk_score_unavailable")) +
                "\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-color--gray" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("RecipientDetail.risk_score_unavailable_text")) +
                "\n\t\t"
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }